import { useCurrentBreakPoint } from '@teliaee/design-system';

export const useIsMobileHook = () => {
  const currentBreak = useCurrentBreakPoint();
  const isMobile = currentBreak === 'xs' || currentBreak === 'sm';
  return { isMobile };
};

export const useIsTabletHook = () => {
  const currentBreak = useCurrentBreakPoint();
  const isTablet = currentBreak === 'md';
  return { isTablet };
};
